import './Button.css';
import PropTypes from 'prop-types';

const Button = (props) => {
  const buttonClasses = ['fmc-button', props.outlined ? 'fmc-button--outlined' : '', props.className || '']
    .filter(Boolean)
    .join(' ');

  return (
    <button className={buttonClasses} onClick={props.onClick} type={props.type || 'button'}>
      {props.label}
      <span className={props.spanClass}></span>
    </button>
  );
};

Button.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  spanClass: PropTypes.string,
  label: PropTypes.string,
  outlined: PropTypes.bool,
  type: PropTypes.string,
};

export default Button;
